import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import styles from './calendarPlayer.css';
import { getPlayerCalendar } from 'data/calendar/actions';
import { saveViewHatch } from 'data/calendar/hatch/actions';
import Header from './components/header/Header';
import CalendarBox from './components/calendarBox/CalendarBox';
import CalendarBoxAlfaLaval from './components/calendarBoxAlfaLaval/CalendarBoxAlfaLaval';
import HatchPopup from './components/hatchPopup/HatchPopup';
import Prizes from './components/header/components/prizes/Prizes';
import Winners from './components/header/components/winners/Winners';
import Leaderboard from './components/header/components/leaderboard/Leaderboard';
import Rules from './components/header/components/rules/Rules';
import { setLocalizationLangs } from 'data/localization/actions';
import get from 'lodash.get';
import {
    getLangCodeById,
    setFonts,
    calculateContentColor,
    setPropxyFonts,
    loadFonts,
    getProxyFont,
    resizeListener,
    wrapUrlByTag
} from '../../../../utils/func';
import { setCookie, checkCookie, deleteCookie } from 'utils/cookieService';
import uuid from 'uuid/v1';
import { loadProxyFont } from '../../../../data/proxyFont/actions';
import EventSound from '../../../../components/calendar/components/question/questionTypes/sound/EventSound';

const { detect } = require( 'detect-browser' );
const browser = detect();
import { withRouter } from 'react-router';
import { setEventSound } from 'data/player/calendar/action';
import { lightOrDark, } from '../../../../utils/lightOrDarkColor';
import { sendUserIdentifier } from '../../../../data/userIdentifier/actions';
import 'moment/locale/sv';
import 'moment/locale/en-gb';
import AcceptCookiesModal from '../../../../components/common/acceptCookies/AcceptCookiesModal';
import moment from 'moment';
import SnowComponent from './components/snowComponent/SnowComponent';
import AcceptCookiesBottom from '../../../../components/common/acceptCookies/AcceptCookiesBottom';
import { getCookie } from '../../../../utils/cookieService';
import ReactDOM from 'react-dom';

const mapStateToProps = ( { identifierUser, hatchGameData, calendar, localization: { content }, reguser, customFonts, gameprogress } ) => ( {
    hatchGameData,
    calendar,
    content,
    reguser,
    customFonts,
    gameprogress,
    identifierUser
} );

const mapDispatchToProps = dispatch => ( {
    calendarPlayerActions: bindActionCreators( {
        getPlayerCalendar,
        setEventSound,
        setLocalizationLangs,
        saveViewHatch,
        loadProxyFont,
        sendUserIdentifier,
    }, dispatch )
} );

@connect( mapStateToProps, mapDispatchToProps )
@withRouter
class CalendarPlayer extends Component {
    constructor( props ) {
        super( props );
        this.state = {
            title: '',
            description: '',
            logo_url: null,
            hatches: null,
            openedHatch: null,
            navigationView: null,
            settings: null,
            registered: false,
            lang_id: 0,
            fontsCreated: false,
            title_style: false,
            description_style: null,
            componentVisible: 'cover',
            animationProcess: false,
            contentColor: {
                light: 'rgba(255, 255, 255, 0.3)',
                dark: 'rgba(255, 255, 255, 1)',
                overlay: 'rgba(0, 0, 0, 0.9)',
                type: 'light'
            },
            windowCalendar: {
                height: 'auto',
                width: 'auto'
            },
            browserInfo: {
                name: null,
                version: null,
                answer: true
            },
            overflow: '',
            fontFamilyH1: {
                fontFamily: 'inherit'
            },
            fontFamilyH2: {
                fontFamily: 'inherit'
            },
            screenType: '',
            userIdentifier: { country: null },
            isCookiesAccepted: false,
            isOpenModal: false,
            isClosedTheHatchPopup: true
        };
        this.DESKTOP = '';
        this.MOBILE = '_mobile';
        this.resizeElm = null;
        this.soundFreezetMethod = undefined;
        this.soundNextPlayMethod = undefined;
    };


    componentDidMount() {
        let versionSplit = browser.version.split( '.' );
        versionSplit = +versionSplit[ 0 ];
        let nameCase = browser.name.toLowerCase();
        const { sendUserIdentifier } = this.props.calendarPlayerActions;
        sendUserIdentifier();
        resizeListener( this.resizeElm, this.onResize );
        const hasUUIDCookie = checkCookie( 'uuid' );
        const isCookiesAccepted = getCookie( 'isCookiesAccepted' );
        this.setState( {
            isCookiesAccepted: isCookiesAccepted,
            browserInfo: { name: nameCase, version: versionSplit }
        } );

        let genUUID = uuid();
        if ( !hasUUIDCookie ) {
            setCookie( 'uuid', genUUID, 1800 );
        }

        window.onresize = () => {
            this.forceUpdate();
        };

        this.getCalendar();

        if ( this.props.calendar ) {
            this.syncState( this.props );
        }

    };

    getCalendar = () => {
        const { calendarPlayerActions: { getPlayerCalendar } } = this.props;
        const params = new URLSearchParams( this.props.location.search );
        const key = params.get( 'key' );
        getPlayerCalendar( this.props.match.params.calendarID, key );
    }

    componentDidUpdate(prevProps) {
        const { calendarPlayerActions: { setLocalizationLangs }, calendar, calendar: { lang_id } } = this.props;
        if ( this.props && calendar && lang_id && this.state.lang_id !== lang_id ) {
            this.setState( { lang_id } );
            setLocalizationLangs( getLangCodeById( lang_id ) );
            if ( lang_id === 2 ) {
                moment.locale( 'sv' );
            } else {
                moment.locale( 'en-gb' );
            }
        }

        if ( JSON.stringify( prevProps?.identifierUser ) !== JSON.stringify( this.props.identifierUser ) ) {
            const { identifierUser } = this.props;
            this.setState( { userIdentifier: identifierUser } );
        }

        if ( this.props.calendar.id!== prevProps.calendar.id && this.props.calendar.id && this.props.calendar.settings.appearance.font_style && !this.state.fontsCreated ) {
            setFonts(this.props.calendar.settings.appearance );
            this.setState( { fontsCreated: true } );
            const { calendarPlayerActions: { loadProxyFont } } = this.props;
            const fontProps = getProxyFont( this.props.calendar.settings.appearance.font_style );
            const { urlFontProps, urlFontFamilyHeader, urlFontFamilyHeaderH2 } = fontProps;
            const form = loadFonts( urlFontProps, urlFontFamilyHeader, urlFontFamilyHeaderH2 );
            loadProxyFont( form );
        }

        if ( this.props.calendar.id!== prevProps.calendar.id && this.props.calendar.id && this.props.calendar.settings.appearance.inner_background ) {
            this.setState( { contentColor: calculateContentColor( this.props.calendar.settings.appearance.inner_background ? this.props.calendar.settings.appearance.inner_background : 'rgba(0, 0, 0, 0.5)' ) } );
        }

        if ( this.props.calendar.id!== prevProps.calendar.id ) {
            this.syncState( this.props );

            if ( this.props.calendar.hatches && prevProps.location ) {
                const { calendar: { lang_id } } = this.props;
                if ( lang_id === 2 ) {
                    moment.locale( 'sv' );
                } else {
                    moment.locale( 'en-gb' );
                }
                this.state.isClosedTheHatchPopup && this.openHatch( this.props );
            }
        }

        if ( process.env.NODE_ENV === 'production' && this.props.calendar.id!== prevProps.calendar.id && JSON.stringify( prevProps.customFonts ) !== JSON.stringify( this.props.customFonts ) ) {
            setPropxyFonts( prevProps.calendar.settings.appearance, this.props.customFonts );
        }

    }

    openHatch = ( props ) => {
        const params = new URLSearchParams( props.location.search );
        const hatchId = params.get( 'hatch' );
        if ( hatchId ) {
            this.setState( { openedHatch: props.calendar.hatches.find( el => el.id == hatchId ) } );
        }
    }

    closeHatchPopup = () => {
        const params = new URLSearchParams( this.props.location.search );
        const hatchId = params.get( 'hatch' );
        if ( hatchId ) {
            this.setState( { openedHatch:  null,  isClosedTheHatchPopup: false} );
        }
    }

    syncState = props => {
        const { calendar } = props;

        this.setState( {
            registered: calendar.playerRegistred ? calendar.playerRegistred : false,
            title: calendar.title,
            description: calendar.description,
            logo_url: calendar.logo ? calendar.logo.url : null,
            screenType: this.detectScreenType(),
            hatches: calendar.hatches,
            settings: calendar.settings,
            description_style: calendar.description_style ? JSON.parse( calendar.description_style ) : null,
            title_style: calendar.title_style ? JSON.parse( calendar.title_style ) : null,
            fontFamilyH1: {
                fontFamily: get( props, 'calendar.settings.appearance.font_style.fontFamilyHeaderH' ) ?
                    get( props, 'calendar.settings.appearance.font_style.fontFamilyH1' )
                    :
                    get( props, 'calendar.settings.appearance.font_style.fontProps' )
                        ?
                        get( props, 'calendar.settings.appearance.font_style.fontFamily' )
                        :
                        this.state.fontFamilyH1.fontFamily
            },
            fontFamilyH2: {
                fontFamily: get( props, 'calendar.settings.appearance.font_style.fontFamilyHeaderH2' ) ?
                    get( props, 'calendar.settings.appearance.font_style.fontFamilyH2' )
                    :
                    get( props, 'calendar.settings.appearance.font_style.fontProps' )
                        ?
                        get( props, 'calendar.settings.appearance.font_style.fontFamily' )
                        :
                        this.state.fontFamilyH2.fontFamily
            }
        } );
    };


    setSound = () => {
        const { calendarPlayerActions: { setEventSound } } = this.props;
        setEventSound( { events: 'hover' } );
    };


    setNavigationView = view => this.setState( { navigationView: view } );

    renderNavigationPage = () => {
        switch ( this.state.navigationView ) {
            case 'prizes': {
                return <Prizes contentColor={ this.state.contentColor } fontFamilyH2={ this.state.fontFamilyH2 }/>;
            }
            case 'leaderboard': {
                return (
                    <Leaderboard contentColor={ this.state.contentColor } fontFamilyH2={ this.state.fontFamilyH2 }/> );
            }
            case 'winners': {
                return ( <Winners contentColor={ this.state.contentColor } fontFamilyH2={ this.state.fontFamilyH2 }/> );
            }
            case 'rules': {
                return ( <Rules contentColor={ this.state.contentColor } fontFamilyH2={ this.state.fontFamilyH2 }/> );
            }
            default: {
                return null;
            }
        }
    };
    /**
     *
     * @param playedHatch
     */
    disablePlayedHatch = playedHatch => {
        let { hatches } = this.state;
        const hatchIndex = hatches.indexOf( hatches.find( hatch => hatch.id === playedHatch.id ) );
        playedHatch.alreadyPlayed = true;
        hatches[ hatchIndex ] = playedHatch;
        this.setState( { hatches } );
    };

    /**
     *
     * @param props
     * @param call
     */
    newCookie = ( props, call ) => {
        if ( props.calendar.settings.clean_cookie ) {
            let genUUID = uuid();
            setCookie( 'uuid', genUUID, 1800 );
            if ( typeof call === 'function' ) {
                call();
            }
            const { calendarPlayerActions: { getPlayerCalendar } } = this.props;
            const params = new URLSearchParams( this.props.location.search );
            const key = params.get( 'key' );
            getPlayerCalendar( this.props.match.params.calendarID, key );
        }
    }

    handleHatchOpen = hatch => {
        const { calendarPlayerActions: { saveViewHatch } } = this.props;
        this.setState( { openedHatch: hatch } );
        this.newCookie( this.props );
        if ( hatch ) {
            saveViewHatch( hatch.id );
        }
    };

    detectScreenType = () => {
        return ( document.documentElement.clientWidth <= 420 ) ? this.MOBILE : this.DESKTOP;
    };

    onResize = () => {
        const newScreenType = this.detectScreenType();
        if ( this.state.screenType !== newScreenType ) {
            this.setState( { screenType: newScreenType } );
        }
    };

    /*******************************************************************************************************************
     *
     * @param func
     * @returns {*}
     */
    setSoundFreeze = func => this.soundFreezetMethod = func;

    /********************************************************************************************************************
     *
     * @param func
     * @returns {*}
     */
    setSoundNextPlay = func => this.soundNextPlayMethod = func;


    setComponentVisible = ( component ) => {
        this.setState( { componentVisible: component } );
    };

    setAnimationProcess = ( flag ) => {
        this.setState( { animationProcess: flag } );
    };

    getNextPlayLink = () => {
        this.eventSoundElm.soundNextPlay();
    };

    getSoundFreezeLink = () => {
        this.eventSoundElm.soundFreeze();
    };


    shouldComponentUpdate( newProps ) {
        if ( this.props.gameprogress.timerProgress !== newProps.gameprogress.timerProgress ) {
            return false;
        } else {
            return true;
        }
    }

    toggleCookies = isCookiesAccepted => {
        this.setState( { isCookiesAccepted } );

        if ( isCookiesAccepted ) {
            setCookie( 'isCookiesAccepted', isCookiesAccepted, 365 * 5 );
        } else {
            setCookie( 'isCookiesAccepted', isCookiesAccepted, 0 );
        }

        if ( isCookiesAccepted ) {
            const hasUUIDCookie = checkCookie( 'uuid' );
            let genUUID = uuid();

            if ( !hasUUIDCookie ) {
                setCookie( 'uuid', genUUID, 1800 );
            }
        }
    };

    getHatchList = () => {
        const { hatches, settings } = this.state;
        return hatches && settings.random_hatches ? hatches?.sort( ( a, b ) => {
            return a.initialIndex - b.initialIndex;
        } ) : hatches?.sort( ( a, b ) => {
            return a.order - b.order;
        } );
    }

    render() {
        const {
            title,
            description,
            logo_url,
            screenType,
            settings,
            openedHatch,
            navigationView,
            registered,
            description_style,
            title_style,
            contentColor,
            overflow,
            componentVisible,
            animationProcess,
            isCookiesAccepted,
            userIdentifier,
            fontFamilyH2,
            isOpenModal
        } = this.state;

        const {
            content,
            calendar
        } = this.props;

        const currentScreenTypeBackground = screenType === this.DESKTOP ?
            get( this.props, 'calendar.background.url' ) : get( this.props, 'calendar.background_mobile.url' );

        const windowSize = window.innerWidth > 783;
        const hideBlock = windowSize ? {} : !openedHatch ? {} : { display: 'none' };
        const paddBlock = windowSize ? {} : !openedHatch ? { padding: '0 2rem' } : {};
        const headerBlock = windowSize ? {} : !openedHatch ? {} : { display: 'none' };
        const location = window.location.origin || '';
        const isDevOrStage = location.includes( 'localhost' ) || location.includes( 'stage' ) || location.includes( '192' );
        /** What is it and why is this needed */
        const titleFontFamily = settings && settings.appearance.font_style.fontFamilyH1 ? settings && settings.appearance.font_style.fontFamilyH1 : settings && settings.appearance.font_style.fontFamily;
        const descriptionFontFamily = settings && settings.appearance.font_style.fontFamilyH2 ? settings && settings.appearance.font_style.fontFamilyH2 : settings && settings.appearance.font_style.fontFamily;
        let isHeaderLight = false;

        if ( calendar.topMenuStyle && calendar.topMenuStyle.borderColor ) {
            isHeaderLight = lightOrDark( calendar.topMenuStyle.borderColor ) === 'light';
        }
        const hatchList = this.getHatchList(); // hatches && settings.random_hatches ?  hatches?.sort( ( a, b ) => { return  a.initialIndex - b.initialIndex; }) :  hatches?.sort( ( a, b ) => { return  a.order - b.order; });

        return (

            ReactDOM.createPortal(
                <div
                    ref={ ( elm ) => {
                        this.resizeElm = elm;
                    } }
                    className={ styles.wrapperBackgr }
                    style={ {
                        overflow,
                        backgroundImage:
                            `linear-gradient(
                            ${ settings ? settings.appearance.background_color : null },
                            ${ settings ? settings.appearance.background_color : null }
                            ),
                            url(${ currentScreenTypeBackground })`
                    } }>
                    { settings && Boolean( settings.snow_effect ) && <SnowComponent/> }

                    { settings && Boolean( settings.desktop_sound_enabled ) &&
                    <EventSound
                        ref={ ( elm ) => {
                            this.eventSoundElm = elm;
                        } }
                        setSoundFreeze={ this.setSoundFreeze }
                        setSoundNextPlay={ this.setSoundNextPlay }
                        calendar={ calendar }
                        currentQuestion={ this.props.hatchGameData }
                        animationProcess={ animationProcess }
                        componentProc={ componentVisible }
                    /> }
                    <div className={ styles.beforeWrapper }></div>
                    { settings &&
                    <Header
                        isHeaderLight={ isHeaderLight }
                        content={ content }
                        setNavigationView={ this.setNavigationView }
                        settings={ settings }
                        logo={ logo_url }
                        calendar={ calendar }
                        style={ headerBlock }/>
                    }
                    <div style={ settings ? {
                        ...paddBlock, ...settings.appearance.font_style,
                        fontFamily: titleFontFamily,
                        color: settings.appearance.font_style.color
                    } : paddBlock }
                         className={ styles.wrapperMenu }>
                        <div
                            style={ settings ? {
                                fontFamily: titleFontFamily,
                                color: settings.appearance.font_style.color, ...title_style
                            } : hideBlock }
                            className={ styles.title }
                        >
                            { title }
                        </div>

                        {
                            navigationView
                                ?
                                this.renderNavigationPage()
                                :
                                openedHatch
                                    ?
                                    <HatchPopup
                                        userIdentifier={ userIdentifier }
                                        handleUpdateCalendar={ this.getCalendar }
                                        handleCloseHatchPopup={ this.closeHatchPopup }
                                        location={ this.props.location }
                                        contentColor={ contentColor }
                                        registered={ registered }
                                        className={ styles.HatchPop }
                                        hatch={ openedHatch }
                                        calendar={ this.props.calendar }
                                        handleHatchOpen={ this.handleHatchOpen }
                                        disablePlayedHatch={ this.disablePlayedHatch }
                                        fontFamilyH2={ fontFamilyH2 }
                                        fontFamily={ descriptionFontFamily }
                                        setComponentVisible={ this.setComponentVisible }
                                        setAnimationProcess={ this.setAnimationProcess }
                                        soundFreezetMethod={ this.soundFreezetMethod }
                                        soundNextPlayMethod={ this.soundNextPlayMethod }
                                    />
                                    :
                                    <div className={ styles.wrapperTextBox }>
                                        <p className={ styles.text }
                                           style={ settings && {
                                               fontFamily: descriptionFontFamily,
                                               color: settings.appearance.font_style.color, ...description_style
                                           } }
                                           dangerouslySetInnerHTML={ { __html: wrapUrlByTag( description ) } }/>

                                        <div className={ styles.wrapperBox }>
                                            {
                                                hatchList?.map( ( hatch, index ) => {
                                                    const isOpenedCustomData = () => {

                                                        if ( Boolean( calendar.settings.hatch_offer ) && isCookiesAccepted ) {

                                                            const toDay = new Date().valueOf();
                                                            const splitedDate = new String( hatch.start_date ).split( ' ' );
                                                            let cutDate = '';

                                                            if ( splitedDate.length > 0 ) {
                                                                cutDate = splitedDate[ 0 ];
                                                            } else {
                                                                cutDate = hatch.start_date;
                                                            }
                                                            const toOpenDate = new Date( cutDate ).valueOf();

                                                            if ( toDay > toOpenDate ) {
                                                                return this.handleHatchOpen;
                                                            } else {

                                                                return hatch.active ? this.handleHatchOpen : null;
                                                            }

                                                        } else {
                                                            return ( Boolean( calendar.settings.hatch_offer ) || !hatch.alreadyPlayed || calendar.settings.passed_hatches )
                                                            && hatch.active ? this.handleHatchOpen : null;
                                                        }
                                                    };

                                                    const isOpenedRangeData = () => {
                                                        return ( Boolean( calendar.settings.hatch_offer ) || !hatch.alreadyPlayed || calendar.settings.passed_hatches )
                                                        && ( !calendar.expired )
                                                        && hatch.active ? this.handleHatchOpen : null;
                                                    };

                                                    return settings.set_specific_dates ?
                                                        <CalendarBoxAlfaLaval
                                                            handleHatchOpen={ isCookiesAccepted && isOpenedCustomData() }
                                                            key={ index }
                                                            hatch={ hatch }
                                                            index={ hatch.order }/> :

                                                        <CalendarBox
                                                            handleHatchOpen={ isOpenedRangeData() }
                                                            key={ index } hatch={ hatch }
                                                            index={ hatch.order }/>;
                                                } ) }
                                        </div>
                                    </div>
                        }

                    </div>
                    {
                        isDevOrStage ?
                            <button className={ styles.resetGame }
                                aria-label={ content.calendar.reset_game_aria_label }
                                    onMouseEnter={ this.setSound }
                                    onClick={ () => {
                                        deleteCookie( 'uuid' );
                                        deleteCookie( 'isCookiesAccepted' );
                                        document.location.reload( true );
                                    }
                                    }>
                                { content.calendar.reset_game }
                            </button>
                            :
                            null
                    }

                    { !isCookiesAccepted && !isOpenModal &&
                    <AcceptCookiesBottom button_style={ get( calendar, 'settings.appearance.button_style' ) }
                                         isCookiesAccepted={ isCookiesAccepted }
                                         toggleCookies={ this.toggleCookies }
                                         content={ content }
                                         showAcceptCookiesModal={ () => this.setState( { isOpenModal: true } ) }
                    />
                    }
                    { isOpenModal &&
                    <AcceptCookiesModal button_style={ get( calendar, 'settings.appearance.button_style' ) }
                                        onClick={ () => this.forceUpdate() }
                                        isCookiesAccepted={ isCookiesAccepted }
                                        toggleCookies={ this.toggleCookies }
                                        actionBtnClick={ () => this.setState( { isOpenModal: false } ) }
                                        content={ content }
                                        closeCookiesModal={ () => this.setState( { isOpenModal: false } ) }/>
                    }

                </div>, document.getElementById( 'player' ) )
        );
    }
}

export default CalendarPlayer;